<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="driverHeadings" :data="drivers" :hasActions="true"
                                :hasNoPaging="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onDriverActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddDriverClick" id="btnLogisticsDriverAddDriver">Add Driver</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="driverMarkAsActiveInactiveModal.heading"
                :modalId="driverMarkAsActiveInactiveModal.modalId"
                :isSaving="driverMarkAsActiveInactiveModal.isSaving"
                :showModal="driverMarkAsActiveInactiveModal.showModal"
                :isActive="driverMarkAsActiveInactiveModal.isActive"
                @closeClicked="driverMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="driverAddEditFormModal.heading"
            :modalId="driverAddEditFormModal.modalId"
            :isSaving="driverAddEditFormModal.isSaving"
            :showModal="driverAddEditFormModal.showModal"
            @closeClicked="onAddOrEditDriverModalCloseClick"
            @saveButtonClicked="onAddOrEditDriverSaveClick">
        <template #form>
            <div class="form-group">
                <label for="firstNameInput">
                    First Name
                </label>
                <div class="text-danger" v-if="driverAddEditFormModal.driver.firstName.hasError">
                    {{driverAddEditFormModal.driver.firstName.errorMessage}}
                </div>
                <input type="text" class="form-control" id="firstNameInput" v-model="driverAddEditFormModal.driver.firstName.value">
            </div>
            <div class="form-group">
                <label for="lastNameInput">
                    Last Name
                </label>
                <div class="text-danger" v-if="driverAddEditFormModal.driver.lastName.hasError">
                    {{driverAddEditFormModal.driver.lastName.errorMessage}}
                </div>
                <input type="text" class="form-control" id="lastNameInput" v-model="driverAddEditFormModal.driver.lastName.value">
            </div>
            <div class="form-group">
                <label for="employeeNumberInput">
                    Employee Number
                </label>
                <div class="text-danger" v-if="driverAddEditFormModal.driver.employeeNumber.hasError">
                    {{driverAddEditFormModal.driver.employeeNumber.errorMessage}}
                </div>
                <input type="text" class="form-control" id="employeeNumberInput" v-model="driverAddEditFormModal.driver.employeeNumber.value">
            </div>
            <div class="form-group">
                <label for="phoneNumberInput">
                    Phone Number
                </label>
                <div class="text-danger" v-if="driverAddEditFormModal.driver.phoneNumber.hasError">
                    {{driverAddEditFormModal.driver.phoneNumber.errorMessage}}
                </div>
                <input type="text" class="form-control" id="phoneNumberInput" v-maska data-maska="### ### ####" v-model="driverAddEditFormModal.driver.phoneNumber.value">
            </div>
        </template>
    </modal-form>
    
    <driver-vehicle-modal
        :heading="driverViewVehicleModal.heading"
        :modalId="driverViewVehicleModal.modalId"
        :showModal="driverViewVehicleModal.showModal"
        :driverId="driverViewVehicleModal.driverId"
        @okClicked="onDriverVehicleModalOkClicked"></driver-vehicle-modal>
</div>
